<template>
  <div class="pre-lesson-list__filter">
    <b-tabs class="pre-lesson-list__filter__tabs">
      <b-tab title="Bài giảng" :active="$route.name !== nameRouteExam" @click="gotoLessonPage()"></b-tab>
      <b-tab title="Soạn đề kiểm tra đánh giá" :active="$route.name === nameRouteExam" @click="gotoExamPage()"></b-tab>
    </b-tabs>
    <div class="pre-lesson-list__filter__action display-flex-center">
      <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add" @click="handleAddNew">
        <i class="icon-plus color-light"></i>
        Thêm mới
      </a>
      <div class="item item__class input-custom-icon select-custom">
        <select class="primary-color-txt border-rd-20 font-size-15 form-h30 color_bg_gray_light border-0 full-width" v-model="paramSearch.classId">
          <option value="0">Lớp - Tất cả</option>
          <option v-for="item of classes" :key="item.classId" :value="item.classId">{{ item.className }}</option>
        </select>
        <i class="icon-arrow-down font-size-13 primary-color"></i>
      </div>
      <div class="item item__subject input-custom-icon select-custom">
        <select class="primary-color-txt border-rd-20 font-size-15 form-h30 color_bg_gray_light border-0 full-width" v-model="paramSearch.subjectId">
          <option value="0">Môn - tất cả</option>
          <option v-for="item of subjects" :key="item.subjectId" :value="item.subjectId">{{ item.subjectName }}</option>
        </select>
        <i class="icon-arrow-down font-size-13 primary-color"></i>
      </div>
      <div class="item item__key input-custom-icon">
        <input 
          v-model.lazy="keyword"
          v-debounce="300"
          type="text"
          placeholder="Tìm kiếm"
          class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width"
        >
        <i class="icon-search font-size-16 primary-color"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { STORE_KEY } from './../../_store/constants'
  import debounce from "@/directives/debounce"
  import classService from './../../_api/classService';

  export default {
    name: 'FilterList',
    data() {
      return {
        keyword: '',
        classes: [],
        subjects: [],
        nameRouteExam: 'examList'
      }
    },
    directives: { debounce },
    computed: {
      ...mapState(STORE_KEY, ['paramSearch'])
    },
    watch: {
      keyword: 'searchByKeyword',
      'paramSearch.classId': 'filterDatasByClass',
      'paramSearch.subjectId': 'filterDatasBySubject'
    },
    created () {
      this.getClasses()
    },
    beforeDestroy () {
      this.acSetParamSearch({classId: 0, subjectId: 0, keyword: '', pageIndex: 1, pageSize: 12});
    },
    methods: {
      ...mapActions(STORE_KEY, ['acSetParamSearch']),

      initPage () {
        if (this.$route.query.lop) {
          this.acSetParamSearch({...this.paramSearch, classId: parseInt(this.$route.query.lop)});
        }
        if (this.$route.query.mon) {
          this.acSetParamSearch({...this.paramSearch, subjectId: parseInt(this.$route.query.mon)});
        }
        if (this.$route.query.s) {
          this.keyword = this.$route.query.s
          this.acSetParamSearch({...this.paramSearch, keyword: this.$route.query.s})
        }
      },

      handleAddNew () {
        let self = this
        const routeName = this.$route.name
        const routerPath = routeName === this.nameRouteExam ? '/soan-de-thi/0' : '/soan-giao-an'
        this.$router.push({path: routerPath})
      },

      searchByKeyword(val) {
        this.acSetParamSearch({...this.paramSearch, keyword: val});
        this.$route.query.s !== this.paramSearch.keyword && this.$router.replace({query: { ...this.$route.query, s: val }})
      },

      gotoLessonPage () {
        this.$router.push('/danh-sach-giao-an')
      },

      gotoExamPage () {
        this.$router.push('/danh-sach-de-thi')
      },

      getClasses () {
        let self = this;
        classService.get().then((res) => {
          if (!res) {
            return;
          }
          self.classes = res;
          self.initPage()
        })
      },

      filterDatasByClass () {
        this.getSubjects()
        this.paramSearch.classId !== parseInt(this.$route.query.lop) && this.$router.replace({query: { lop: this.paramSearch.classId }})
      },

      getSubjects () {
        let indexClassActive = this.classes.findIndex(cl => cl.classId === parseInt(this.paramSearch.classId))
        if (indexClassActive > -1 && this.classes[indexClassActive]) {
          this.subjects = this.classes[indexClassActive].subjects
        }
      },

      filterDatasBySubject () {
        this.paramSearch.subjectId !== parseInt(this.$route.query.mon) && this.$router.replace({query: { ...this.$route.query, mon: this.paramSearch.subjectId }})
      }
    }
  }
</script>
<style lang="scss" scoped> 
    @import '~@/assets/scss/general';
    .pre-lesson-list {
      &__filter {
        padding: 40px 0 15px;

        &__action {
          padding-top: 45px;
        }

        .item {
          
          &:not(:last-child) {
            margin-right: 15px;
          }

          &__add {
            min-width: 135px;

            i {
              margin-right: 6px;
            }
          }

          &__class {
            max-width: 160px;
          }

          &__subject {
            max-width: 260px;
          }

          &__key {
            min-width: 300px;
          }
        }

        @media screen and ( max-width: 991px ) {
          &__action {
            display: block;
            padding-top: 25px;
          }
          .item {
            margin-bottom: 10px;
            
            &:not(:last-child) {
              margin-right: 0
            }

            &__add {
              justify-content: center;
            }
          }
        }

        @media screen and ( min-width: 768px ) and ( max-width: 991px ) {
          .item {

            &__class, &__subject {
              display: inline-block;
            }

            &__class {
              margin-right: 2%!important;
              max-width: 30%;
            }

            &__subject {
              max-width: 68%;
            }
          }
        }

        @media screen and ( max-width: 767px ) {
          .item {
            &__class, &__subject {
              display: block;
              max-width: 100%;
            }

            &__key {
              min-width: 100%;
            }
          }
        }
      }
    }
</style>